var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (profile) {
buf.push("<div class=\"partner2-about\"><p>" + (jade.escape(null == (jade_interp = profile.get('full_bio')) ? "" : jade_interp)) + "</p></div>");}.call(this,"profile" in locals_for_with?locals_for_with.profile:typeof profile!=="undefined"?profile:undefined));;return buf.join("");
};
module.exports = template;